__turbopack_context__.v({
  "contains_arrow_icons": "styles-module-scss-module__k8OqlG__contains_arrow_icons",
  "link_list": "styles-module-scss-module__k8OqlG__link_list",
});
